<template>
  <section v-editable="blok" :class="getComponentClass(blok, animationClass)">
    <div class="container">
      <div class="article__body row">
        <div v-if="blok.background" class="article__background">
          {{ blok.background }}
        </div>

        <div :class="'col-12'">
          <h2
            :class="blok.is100wide ? 'article__title--wide' : ''"
            class="article__title"
          >
            {{ blok.body_title }}
          </h2>
        </div>

        <div
          :class="blok.is100wide ? 'col-12' : 'col-12 col-md-6'"
          class="article__body-left"
        >
          <component
            :is="item.component | dashify"
            v-for="item in blok.body_left"
            :key="item._uid"
            :blok="item"
            :modifier-class="getModifierClass(item.component)"
          />
        </div>

        <template v-if="!blok.is100wide">
          <div
            v-for="item in blok.body_right"
            :key="item._uid"
            class="col-12 col-md-6 article__body-right"
          >
            <component
              :is="item.component | dashify"
              :blok="item"
              :modifier-class="getModifierClass(item.component)"
            />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Article',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    visibleSectionIndex: {
      type: Number,
      default: () => 1000,
    },
  },
  data() {
    return {
      animationClass: 'article--animate',
      isAnimationActive: true,
    }
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.$store.commit(
          'globals/setVisibleSectionName',
          this.blok.breadcrumb
        )
        this.$store.commit(
          'globals/setVisibleSectionIndex',
          this.visibleSectionIndex
        )
        if (this.isAnimationActive) {
          this.animationClass = ' article--animate article--animate-done'
          this.isAnimationActive = false
        }
      }
    },
  },
  methods: {
    getComponentClass(blok, animationClass) {
      const shadow = blok.hasShadow ? ' article--shadow' : ''
      const height = blok.isHScreen ? ' h-screen' : 'h-default'
      const width = blok.is100wide ? ' article--single-column' : ''
      const space = blok.space ? `space--${blok.space}` : 'space--small'
      return `theme-light article ${shadow} ${width} ${height} ${animationClass} ${space}`
    },
    getModifierClass: (componentName) => {
      switch (componentName) {
        case 'a_link':
          return 'icon icon--arrow article__link'
        default:
          return 'article__text'
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.article {
  position: relative;
  overflow: hidden;

  &.h-default {
    min-height: 0;
  }

  &--shadow {
    overflow: hidden;
    &::before {
      @extend %block-shadow;
    }
  }

  &--single-column {
    .article__title,
    .article__text {
      max-width: 770px;
      margin: 0 auto;
    }

    .article-quote {
      padding: 0;

      &__copy {
        margin: 0;
      }
    }
  }

  &--animate {
    .article__title {
      opacity: 0;
      transform: translate(0, 30px);
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.1s;
    }
    .article__body-left,
    .article__body-right {
      opacity: 0;
      transform: translate(0, 30px);
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.15s;
    }
  }
  &--animate-done {
    .article__title,
    .article__body-left,
    .article__body-right {
      transform: translate(0, 0);
      opacity: 1;
    }
  }

  .article-quote {
    background: transparent;

    &--animate {
      .article-quote__citation,
      .article-quote__copy {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }

  .article__body {
    padding: inherit;
  }
}

.article__title {
  @include font-family($font-family-headings-bold, $headings-font-weight);
  @include font-size(36);

  margin-top: spacer();
}

.article__body {
  position: relative;

  p {
    margin-top: 16px;
    margin-bottom: 16px;
  }
}

.article__background {
  @include font-family($font-family-headings-bold, $headings-font-weight);
  @include font-size(250, rem-v(250));

  display: none;
  position: absolute;
  width: 100%;
  z-index: 0;
  color: $background-text;
  text-align: center;
}

.article__text {
  margin-bottom: spacer();
}

.article__link {
  &::before {
    @include font-size(10);

    margin-right: 10px;
  }
}

@include media-breakpoint-up(md) {
  .article {
    &--single-column {
      .article__text {
        min-height: 150px;
      }
    }
  }

  .article__background {
    display: block;
  }

  .article__title {
    max-width: 50%;

    &--wide {
      max-width: none;
    }
  }
}

@include media-breakpoint-up(lg) {
  .article__body {
    .article__title {
      margin-top: 0;
      margin-bottom: 10px;
    }

    p {
      font-weight: 500;
      line-height: 28px;
    }
  }

  .article__background {
    @include font-size(400, rem-v(400));
  }
}
</style>
